/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: frLTK57AGre4oWC8c14hh8
// Component: uya55E_l7myk

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import Button from "../../Button"; // plasmic-import: Cr5zp7a53Igt/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: frLTK57AGre4oWC8c14hh8/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: frLTK57AGre4oWC8c14hh8/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicGdpr.module.css"; // plasmic-import: uya55E_l7myk/css

import CircleIcon from "./icons/PlasmicIcon__Circle"; // plasmic-import: 9sHJQRmA0elH/icon
import ChevronDownIcon from "./icons/PlasmicIcon__ChevronDown"; // plasmic-import: BcA8RyhY-uEx/icon

const emptyProxy: any = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q: any): any {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export type PageCtx = {
  pageRoute: string;
  pagePath: string;
  params: Record<string, string | string[] | undefined>;
  query: Record<string, string | string[] | undefined>;
};

export function generateDynamicMetadata($q: any, $ctx: PageCtx) {
  return {
    title: "Informace o zpracování osobních údajů",

    openGraph: {
      title: "Informace o zpracování osobních údajů"
    },
    twitter: {
      card: "summary" as const,
      title: "Informace o zpracování osobních údajů"
    }
  };
}

createPlasmicElementProxy;

export type PlasmicGdpr__VariantMembers = {};
export type PlasmicGdpr__VariantsArgs = {};
type VariantPropType = keyof PlasmicGdpr__VariantsArgs;
export const PlasmicGdpr__VariantProps = new Array<VariantPropType>();

export type PlasmicGdpr__ArgsType = {};
type ArgPropType = keyof PlasmicGdpr__ArgsType;
export const PlasmicGdpr__ArgProps = new Array<ArgPropType>();

export type PlasmicGdpr__OverridesType = {
  root?: Flex__<"div">;
  freeBox?: Flex__<"div">;
  button?: Flex__<typeof Button>;
};

export interface DefaultGdprProps {}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicGdpr__RenderFunc(props: {
  variants: PlasmicGdpr__VariantsArgs;
  args: PlasmicGdpr__ArgsType;
  overrides: PlasmicGdpr__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const pageMetadata = generateDynamicMetadata(
    wrapQueriesWithLoadingProxy({}),
    $ctx as PageCtx
  );

  const styleTokensClassNames = _useStyleTokens();

  return (
    <React.Fragment>
      <Head>
        <meta name="twitter:card" content="summary" />
        <title key="title">{pageMetadata.title}</title>
        <meta key="og:title" property="og:title" content={pageMetadata.title} />
        <meta
          key="twitter:title"
          property="twitter:title"
          content={pageMetadata.title}
        />
      </Head>

      <style>{`
        body {
          margin: 0;
        }
      `}</style>

      <div className={"plasmic_page_wrapper"}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            "all",
            "root_reset_frLTK57AGre4oWC8c14hh8",
            "plasmic_default_styles",
            "plasmic_mixins",
            styleTokensClassNames,
            sty.root
          )}
        >
          <div
            data-plasmic-name={"freeBox"}
            data-plasmic-override={overrides.freeBox}
            className={classNames("all", sty.freeBox)}
          >
            <h1
              className={classNames(
                "all",
                "h1",
                "h1__frLTK",
                "__wab_text",
                sty.h1__qls2
              )}
            >
              {"Informace o zpracov\u00e1n\u00ed osobn\u00edch \u00fadaj\u016f"}
            </h1>
            <h1
              className={classNames(
                "all",
                "h1",
                "h1__frLTK",
                "__wab_text",
                sty.h1__kV4Wz
              )}
            >
              {
                "Kdo jsme a jak\u00e9 Va\u0161e osobn\u00ed \u00fadaje zpracov\u00e1v\u00e1me?"
              }
            </h1>
            <div className={classNames("all", "__wab_text", sty.text__tv3Op)}>
              {
                "Jsme spole\u010dnost FinBakers s.r.o., Na Folimance 2155/15, Vinohrady (Praha 2), 120 00 Praha, I\u010cO: 091 515 41, zapsan\u00e1 v obchodn\u00edm rejst\u0159\u00edku veden\u00e9m M\u011bstsk\u00fdm soudem v Praze pod sp. zn. C 331699 (d\u00e1le jen \u201emy\u201c, \u201espole\u010dnost\u201c nebo \u201espr\u00e1vce\u201c) a zpracov\u00e1v\u00e1me ve smyslu na\u0159\u00edzen\u00ed Evropsk\u00e9ho parlamentu a Rady (EU) \u010d. 2016/679 o ochran\u011b fyzick\u00fdch osob v souvislosti se zpracov\u00e1n\u00edm osobn\u00edch \u00fadaj\u016f a o voln\u00e9m pohybu t\u011bchto \u00fadaj\u016f a o zru\u0161en\u00ed sm\u011brnice 95/46/ES (obecn\u00e9 na\u0159\u00edzen\u00ed o ochran\u011b osobn\u00edch \u00fadaj\u016f) (d\u00e1le jen \u201eNa\u0159\u00edzen\u00ed\u201c) ve spojen\u00ed se z\u00e1konem \u010d. 110/2019 Sb., o zpracov\u00e1n\u00ed osobn\u00edch \u00fadaj\u016f, Va\u0161e n\u00e1sleduj\u00edc\u00ed osobn\u00ed \u00fadaje."
              }
            </div>
            <div className={classNames("all", "__wab_text", sty.text__bhZP)}>
              {"Jde p\u0159edev\u0161\u00edm o tyto osobn\u00ed \u00fadaje:"}
            </div>
            <div className={classNames("all", "__wab_text", sty.text__qv0Cj)}>
              <React.Fragment>
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul___3Cd3H
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__pxoeg
                      )}
                    >
                      {
                        "jm\u00e9no, p\u0159\u00edjmen\u00ed a osobn\u00ed identifika\u010dn\u00ed \u010d\u00edslo rodn\u00e9 \u010d\u00edslo, \u010d\u00edslo ob\u010dansk\u00e9ho, pop\u0159. jin\u00e9ho pr\u016fkazu);"
                      }
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__xsjQ
                      )}
                    >
                      {"adresa trval\u00e9ho nebo jin\u00e9ho pobytu;"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__foZcs
                      )}
                    >
                      {"st\u00e1tn\u00ed ob\u010danstv\u00ed;"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__ru8Os
                      )}
                    >
                      {"m\u00edsto narozen\u00ed;"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__uZLaq
                      )}
                    >
                      {"rodinn\u00fd stav;"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__vnULl
                      )}
                    >
                      {
                        "nejvy\u0161\u0161\u00ed dosa\u017een\u00e9 vzd\u011bl\u00e1n\u00ed;"
                      }
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__o9CNm
                      )}
                    >
                      {"po\u010det vy\u017eivovan\u00fdch d\u011bt\u00ed;"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__xnc1L
                      )}
                    >
                      {"zp\u016fsob bydlen\u00ed;"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__unaay
                      )}
                    >
                      {"I\u010cO;"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__ps6Ve
                      )}
                    >
                      {"\u010d\u00edslo mobiln\u00edho telefonu;"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__k171
                      )}
                    >
                      {"e-mailov\u00e1 adresa;"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__dg88Q
                      )}
                    >
                      {"\u010d\u00edslo bankovn\u00edho \u00fa\u010dtu;"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__sPQtx
                      )}
                    >
                      {"nahr\u00e1van\u00e9 telefonn\u00ed hovory;"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__kL190
                      )}
                    >
                      {
                        "informace o pravideln\u00fdch p\u0159\u00edjmech a jejich zdroji a informace o pravideln\u00fdch v\u00fddaj\u00edch;"
                      }
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__hg0Ag
                      )}
                    >
                      {"informace o dom\u00e1cnosti;"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__rrrr0
                      )}
                    >
                      {"dal\u0161\u00ed kontaktn\u00ed informace;"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__q8TeW
                      )}
                    >
                      {
                        "v\u00fdpis z bankovn\u00edho \u00fa\u010dtu a\u017e za posledn\u00edch 12 m\u011bs\u00edc\u016f v\u010detn\u011b ve\u0161ker\u00fdch transakc\u00ed na v\u00fdpisu;"
                      }
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__psnx5
                      )}
                    >
                      {
                        "informace z \u00fav\u011brov\u00fdch datab\u00e1z\u00ed a ve\u0159ejn\u00fdch registr\u016f;"
                      }
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__jjKmc
                      )}
                    >
                      {
                        "kopie doklad\u016f poskytnut\u00fdch za \u00fa\u010delem pln\u011bn\u00ed na\u0161ich povinnost\u00ed p\u0159ed uzav\u0159en\u00edm Smlouvy nebo v pr\u016fb\u011bhu jej\u00edho trv\u00e1n\u00ed;"
                      }
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__cyydZ
                      )}
                    >
                      {
                        "pop\u0159. dal\u0161\u00ed pot\u0159ebn\u00e9 doklady \u010di dokumenty."
                      }
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
              </React.Fragment>
            </div>
            <h1
              className={classNames(
                "all",
                "h1",
                "h1__frLTK",
                "__wab_text",
                sty.h1__nsok4
              )}
            >
              {
                "Za jak\u00fdmi \u00fa\u010dely Va\u0161e osobn\u00ed \u00fadaje zpracov\u00e1v\u00e1me?"
              }
            </h1>
            <div className={classNames("all", "__wab_text", sty.text___0HuIh)}>
              {
                "Va\u0161e osobn\u00ed \u00fadaje zpracov\u00e1v\u00e1me, abychom V\u00e1m mohli poskytovat na\u0161i slu\u017ebu v podob\u011b zprost\u0159edkov\u00e1n\u00ed \u00fav\u011bru (d\u00e1le jen \u201eSlu\u017eba\u201c), tedy za \u00fa\u010delem uzav\u0159en\u00ed a pln\u011bn\u00ed smlouvy o zprost\u0159edkov\u00e1n\u00ed \u00fav\u011bru. Podm\u00ednky poskytov\u00e1n\u00ed Slu\u017eby jsou definov\u00e1ny v obchodn\u00edch podm\u00ednk\u00e1ch dostupn\u00fdch zde (d\u00e1le jen \u201eObchodn\u00ed podm\u00ednky\u201c). Pro jin\u00fd \u00fa\u010del m\u016f\u017eeme zpracov\u00e1vat osobn\u00ed \u00fadaje pouze, pokud je takov\u00fd \u00fa\u010del slu\u010diteln\u00fd s p\u016fvodn\u00edm \u00fa\u010delem nebo jsme k takov\u00e9mu \u00fa\u010delu zpracov\u00e1n\u00ed opr\u00e1vn\u011bni."
              }
            </div>
            <h1
              className={classNames(
                "all",
                "h1",
                "h1__frLTK",
                "__wab_text",
                sty.h1__iDfRm
              )}
            >
              {
                "Pro \u0159\u00e1dn\u00e9 poskytnut\u00ed Slu\u017eby je nutn\u00e9, abychom p\u0159edev\u0161\u00edm:"
              }
            </h1>
            <div className={classNames("all", "__wab_text", sty.text__x8EDw)}>
              {
                "a) prov\u011b\u0159ili osobn\u00ed \u00fadaje v na\u0161\u00ed intern\u00ed datab\u00e1zi, zkontrolovali osobn\u00ed \u00fadaje (p\u0159edev\u0161\u00edm dostate\u010dnosti jejich rozsahu a obsahu pro p\u0159\u00edpadn\u00e9 zprost\u0159edkov\u00e1n\u00ed smlouvy o \u00fav\u011bru), a porovnali osobn\u00ed \u00fadaje s krit\u00e9rii stanoven\u00fdmi jednotliv\u00fdmi poskytovateli \u00fav\u011bru. V t\u00e9to souvislosti jsme opr\u00e1vn\u011bni kontaktovat dal\u0161\u00ed osoby za \u00fa\u010delem mimo jin\u00e9 zji\u0161t\u011bn\u00ed a potvrzen\u00ed informac\u00ed, je\u017e jste uvedl(a) v \u017e\u00e1dosti o zprost\u0159edkov\u00e1n\u00ed \u00fav\u011bru,\n\nb) p\u0159edali osobn\u00ed \u00fadaje poskytovateli (poskytovatel\u016fm) \u00fav\u011bru (d\u00e1le jen \u201ePoskytovatel\u00e9\u201c) za \u00fa\u010delem prov\u011b\u0159en\u00ed v jeho (jejich) intern\u00ed datab\u00e1zi (datab\u00e1z\u00edch) a nahl\u00e9dnut\u00ed do ve\u0159ejn\u00fdch rejst\u0159\u00edk\u016f a informa\u010dn\u00edch datab\u00e1z\u00ed, jejich\u017e prost\u0159ednictv\u00edm jsou poskytovatel\u00e9 \u00fav\u011bru opr\u00e1vn\u011bni se vz\u00e1jemn\u011b informovat o identifika\u010dn\u00edch \u00fadaj\u00edch spot\u0159ebitel\u016f a o z\u00e1le\u017eitostech, kter\u00e9 vypov\u00eddaj\u00ed o bonit\u011b, platebn\u00ed mor\u00e1lce a d\u016fv\u011bryhodnosti spot\u0159ebitel\u016f (d\u00e1le jen \u201eRegistr\u201c), a to v souladu se z\u00e1konem \u010d. 257/2016 Sb., o spot\u0159ebitelsk\u00e9m \u00fav\u011bru. Poskytovatel\u00e9 vyu\u017e\u00edvaj\u00ed zejm\u00e9na n\u00e1sleduj\u00edc\u00ed Registry, kter\u00e9 se mohou d\u00e1le pod\u00edlet na zpracov\u00e1n\u00ed osobn\u00edch \u00fadaj\u016f jako zpracovatel\u00e9 osobn\u00edch \u00fadaj\u016f:"
              }
            </div>
            <div className={classNames("all", "__wab_text", sty.text___2Fx0X)}>
              <React.Fragment>
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul__nltTm
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__kJ3T
                      )}
                    >
                      {
                        "registry z\u00e1jmov\u00e9ho sdru\u017een\u00ed pr\u00e1vnick\u00fdch osob SOLUS (I\u010c 69346925),"
                      }
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul___1UCz
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li___5EAd
                      )}
                    >
                      {
                        "registr CBCB \u2013 Czech Banking Credit Bureau, a.s. (BRKI, I\u010cO 26199696),"
                      }
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul__tbniO
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__sUZp
                      )}
                    >
                      {
                        "registr CNCB \u2013 Czech Non-Banking Credit Bureau, z.s.p.o. (NRKI, I\u010c 71236384),"
                      }
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul__zTbhd
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li___74Rk
                      )}
                    >
                      {
                        "registry spole\u010dnost\u00ed CRIF - Czech Credit Bureau (I\u010c 26212242),"
                      }
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul__oXe0Y
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li___5Ge5Y
                      )}
                    >
                      {
                        "registr spole\u010dnosti CRIF - Registr platebn\u00edch informac\u00ed s. r. o. (REPI, I\u010c 05775809),"
                      }
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul__ucw1H
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__nNj88
                      )}
                    >
                      {
                        "registr Spole\u010dnosti pro informa\u010dn\u00ed datab\u00e1ze, a.s. (TelcoScore, I\u010c 26118513),"
                      }
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul___4QxR
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__x8FKs
                      )}
                    >
                      {
                        "registr z\u00e1jmov\u00e9ho spolku Asociace poskytovatel\u016f nebankovn\u00edch \u00fav\u011br\u016f (I\u010c 02734311),"
                      }
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul__inPQb
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__hk8K1
                      )}
                    >
                      {
                        "registr spole\u010dnosti Sokordia, s.r.o, I\u010c 29190088,"
                      }
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul__dbac3
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__vDjSr
                      )}
                    >
                      {"insolven\u010dn\u00ed rejst\u0159\u00edk (ISIR),"}
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul__sExHs
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__srhQw
                      )}
                    >
                      {
                        "datab\u00e1ze Ministerstva vnitra \u010cesk\u00e9 republiky pro ov\u011b\u0159en\u00ed platnosti osobn\u00edch doklad\u016f,"
                      }
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul__kXfpu
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__oAn8B
                      )}
                    >
                      {"katastr nemovitost\u00ed,"}
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul__m9Yn7
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__c9Pz3
                      )}
                    >
                      {
                        "Asociace poskytovatel\u016f nebankovn\u00edch \u00fav\u011br\u016f, z. s., I\u010c 027 34 311,"
                      }
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul___81Iy7
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li___3Cjxn
                      )}
                    >
                      {"O2 Czech republic a.s., I\u010c: 601 93 336,"}
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul__meih7
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__uyTzB
                      )}
                    >
                      {"O2 Family, s.r.o., I\u010c: 242 15 554,"}
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul__yFoig
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__ixOaK
                      )}
                    >
                      {"T-mobile Czech Republic, a.s., I\u010c: 649 49 681,"}
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul__aeqAo
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__lfisB
                      )}
                    >
                      {"Vodafone Czech Republic a.s., I\u010c: 257 88 001."}
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
              </React.Fragment>
            </div>
            <div className={classNames("all", "__wab_text", sty.text__svf9O)}>
              {
                "Va\u0161e osobn\u00ed \u00fadaje d\u00e1le zpracov\u00e1v\u00e1me, ukl\u00e1d\u00e1-li n\u00e1m to z\u00e1kon (nap\u0159\u00edklad pln\u011bn\u00ed povinnost\u00ed podle z\u00e1kona \u010d. 253/2008 Sb., o n\u011bkter\u00fdch opat\u0159en\u00edch proti legalizaci v\u00fdnos\u016f z trestn\u00e9 \u010dinnosti a financov\u00e1n\u00ed terorismu, nebo podle z\u00e1kona \u010d. 257/2016 Sb., o spot\u0159ebitelsk\u00e9m \u00fav\u011bru) nebo je-li to nezbytn\u00e9 k ochran\u011b pr\u00e1v a opr\u00e1vn\u011bn\u00fdch z\u00e1jm\u016f nebo sv\u011bd\u010d\u00ed-li n\u00e1m opr\u00e1vn\u011bn\u00fd z\u00e1jem (nap\u0159\u00edklad marketingov\u00e9 \u00fa\u010dely).\n\nPokud n\u00e1m k tomu d\u00e1te souhlas, zpracov\u00e1v\u00e1me Va\u0161e osobn\u00ed \u00fadaje i na z\u00e1klad\u011b Va\u0161eho souhlasu a v souladu s n\u00edm, pro \u00fa\u010del, pro kter\u00fd n\u00e1m byl souhlas ud\u011blen. A to a\u017e do doby, ne\u017e tento souhlas odvol\u00e1te.\n\nSouhlas m\u016f\u017eete odvolat kdykoliv bez ud\u00e1n\u00ed d\u016fvod\u016f. Berte na v\u011bdom\u00ed, \u017ee odvol\u00e1n\u00ed souhlasu nem\u00e1 vliv na p\u0159edchoz\u00ed zpracov\u00e1n\u00ed osobn\u00edch \u00fadaj\u016f, ani na dal\u0161\u00ed zpracov\u00e1n\u00ed osobn\u00edch \u00fadaj\u016f, k n\u011bmu\u017e doch\u00e1z\u00ed z jin\u00e9ho pr\u00e1vn\u00edho titulu."
              }
            </div>
            <h1
              className={classNames(
                "all",
                "h1",
                "h1__frLTK",
                "__wab_text",
                sty.h1__w66W
              )}
            >
              {"Doba zpracov\u00e1n\u00ed"}
            </h1>
            <div className={classNames("all", "__wab_text", sty.text__v6BoO)}>
              {
                "Doba zpracov\u00e1n\u00ed je stanovena na dobu nezbytn\u011b nutnou pro napln\u011bn\u00ed \u00fa\u010delu zpracov\u00e1n\u00ed a/nebo vy\u017eadovanou z\u00e1konn\u00fdmi lh\u016ftami pro uchov\u00e1v\u00e1n\u00ed (archivaci) pro zvolen\u00fd \u00fa\u010del zpracov\u00e1n\u00ed.\n\nPo ukon\u010den\u00ed doby zpracov\u00e1n\u00ed budou Va\u0161e osobn\u00ed \u00fadaje likvidov\u00e1ny, leda\u017ee jejich uchov\u00e1n\u00ed ukl\u00e1d\u00e1 pr\u00e1vn\u00ed p\u0159edpis nebo m\u016f\u017ee b\u00fdt p\u0159edlo\u017een\u00ed \u00fadaj\u016f vy\u017eadov\u00e1no org\u00e1nem dozoru nebo je jejich uchov\u00e1n\u00ed nutn\u00e9 pro pln\u011bn\u00ed uzav\u0159en\u00e9 smlouvy.\n\nDoba zpracov\u00e1n\u00ed pro \u00fa\u010del poskytnut\u00ed Slu\u017eby \u010din\u00ed v n\u00e1vaznosti na dobu \u00fa\u010dinnosti smlouvy o poskytnut\u00ed Slu\u017eby 10 let, nen\u00ed-li smlouva o poskytnut\u00ed Slu\u017eby ukon\u010dena d\u0159\u00edve, a d\u00e1le po dobu nezbytnou k pln\u011bn\u00ed archiva\u010dn\u00edch povinnost\u00ed podle p\u0159\u00edslu\u0161n\u00fdch pr\u00e1vn\u00edch p\u0159edpis\u016f."
              }
            </div>
            <h1
              className={classNames(
                "all",
                "h1",
                "h1__frLTK",
                "__wab_text",
                sty.h1__eifQy
              )}
            >
              {
                "Kdo n\u00e1m m\u016f\u017ee se zpracov\u00e1n\u00edm Va\u0161ich \u00fadaj\u016f pomoci a za jak\u00fdmi \u00fa\u010dely?"
              }
            </h1>
            <div className={classNames("all", "__wab_text", sty.text__wlLrj)}>
              {
                "V souvislosti s poskytov\u00e1n\u00edm Slu\u017eby jsou p\u0159\u00edjemci Va\u0161ich osobn\u00edch \u00fadaj\u016f poskytovatel\u00e9 spot\u0159ebitelsk\u00e9ho \u00fav\u011bru ve smyslu ustanoven\u00ed \u00a7 7 a n\u00e1sl. z\u00e1kona \u010d. 257/2016 Sb., o spot\u0159ebitelsk\u00e9m \u00fav\u011bru, a poskytovatel\u00e9 jin\u00fdch ne\u017e spot\u0159ebitelsk\u00fdch \u00fav\u011br\u016f, pokud Subjekt nen\u00ed spot\u0159ebitelem, event. jin\u00ed zprost\u0159edkovatel\u00e9 \u00fav\u011bru. Poskytovatel finan\u010dn\u00edho produktu n\u00e1s n\u00e1sledn\u011b m\u016f\u017ee informovat o stavu Va\u0161\u00ed \u017e\u00e1dosti o finan\u010dn\u00ed slu\u017ebu, a to za \u00fa\u010delem vz\u00e1jemn\u00e9ho finan\u010dn\u00edho vypo\u0159\u00e1d\u00e1n\u00ed."
              }
            </div>
            <div className={classNames("all", "__wab_text", sty.text__b1HRd)}>
              {
                "Na zpracov\u00e1n\u00ed osobn\u00edch \u00fadaj\u016f se mohou po omezenou dobu pod\u00edlet tak\u00e9 dal\u0161\u00ed zpracovatel\u00e9, event. spr\u00e1vci, jejich\u017e slu\u017eby vyu\u017e\u00edv\u00e1me pro spln\u011bn\u00ed v\u00fd\u0161e uveden\u00fdch \u00fa\u010del\u016f a za \u00fa\u010delem spln\u011bn\u00ed sv\u00fdch z\u00e1konn\u00fdch povinnost\u00ed stanoven\u00fdch dal\u0161\u00edmi pr\u00e1vn\u00edmi p\u0159edpisy. Mezi takov\u00e9 zpracovatele/spr\u00e1vce pat\u0159\u00ed:"
              }
            </div>
            <div className={classNames("all", "__wab_text", sty.text__frAoc)}>
              <React.Fragment>
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul__lJCwM
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li___4Jljd
                      )}
                    >
                      {"marketingov\u00e9 spole\u010dnosti,"}
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul__zoN2M
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__n4FG
                      )}
                    >
                      {"\u00fa\u010detn\u00ed spole\u010dnosti,"}
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul___3HoIz
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__p9Ghj
                      )}
                    >
                      {"auditorsk\u00e9 spole\u010dnosti,"}
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul__vc4Yp
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__kXnOa
                      )}
                    >
                      {
                        "spole\u010dnosti poskytuj\u00edc\u00ed pr\u00e1vn\u00ed slu\u017eby,"
                      }
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul__ih87V
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__qr3Tj
                      )}
                    >
                      {
                        "spole\u010dnosti zab\u00fdvaj\u00edc\u00ed se personalistikou a vzd\u011bl\u00e1v\u00e1n\u00edm,"
                      }
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul__nTs72
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__ueUM
                      )}
                    >
                      {"spole\u010dnosti poskytuj\u00edc\u00ed IT slu\u017eby,"}
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul___4Sxa2
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__iOz8O
                      )}
                    >
                      {
                        "spole\u010dnosti zab\u00fdvaj\u00edc\u00ed se internetov\u00fdm marketingem,"
                      }
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul___8Dz5X
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__kLr45
                      )}
                    >
                      {
                        "spole\u010dnosti zab\u00fdvaj\u00edc\u00ed se v\u00fdvojem, prodejem a servisem marketingov\u00fdch syst\u00e9m\u016f,"
                      }
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul__x251L
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__if5F6
                      )}
                    >
                      {
                        "spole\u010dnosti zab\u00fdvaj\u00edc\u00ed se v\u00fdvojem a implementac\u00ed podnikov\u00fdch syst\u00e9m\u016f,"
                      }
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul__yxx4U
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__lj7OR
                      )}
                    >
                      {
                        "spole\u010dnosti zab\u00fdvaj\u00edc\u00ed se v\u00fdvojem webov\u00fdch a mobiln\u00edch aplikac\u00ed, spole\u010dnosti poskytuj\u00edc\u00ed software licenci pro online komunikaci."
                      }
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
              </React.Fragment>
            </div>
            <div className={classNames("all", "__wab_text", sty.text__uxa6G)}>
              {
                "P\u0159esn\u00fd v\u00fd\u010det p\u0159\u00edjemc\u016f Va\u0161ich osobn\u00edch \u00fadaj\u016f V\u00e1m r\u00e1di poskytneme k Va\u0161emu dotazu.\n\nVa\u0161e osobn\u00ed \u00fadaje nep\u0159ed\u00e1v\u00e1me do t\u0159et\u00edch zem\u00ed (mimo EU), ani mezin\u00e1rodn\u00edm organizac\u00edm.\n\nPo p\u0159ed\u00e1n\u00ed osobn\u00edch \u00fadaj\u016f jin\u00e9mu spr\u00e1vci neneseme odpov\u011bdnost za zpracov\u00e1n\u00ed osobn\u00edch \u00fadaj\u016f t\u00edmto samostatn\u00fdm spr\u00e1vcem."
              }
            </div>
            <h1
              className={classNames(
                "all",
                "h1",
                "h1__frLTK",
                "__wab_text",
                sty.h1__fITq0
              )}
            >
              {"Zas\u00edl\u00e1n\u00ed obchodn\u00edch sd\u011blen\u00ed"}
            </h1>
            <div className={classNames("all", "__wab_text", sty.text__uzZu3)}>
              {
                "Elektronick\u00e9 kontakty, kter\u00e9 od v\u00e1s z\u00edsk\u00e1me v souvislosti s jedn\u00e1n\u00edm o uzav\u0159en\u00ed smlouvy, m\u016f\u017eeme vyu\u017e\u00edt pro zas\u00edl\u00e1n\u00ed obchodn\u00edch sd\u011blen\u00ed t\u00fdkaj\u00edc\u00edch se stejn\u00fdch nebo obdobn\u00fdch slu\u017eeb, a to a\u017e do doby, kdy s takov\u00fdm zpracov\u00e1n\u00edm vyj\u00e1d\u0159\u00edte nesouhlas. Takov\u00fd postup umo\u017e\u0148uje ustanoven\u00ed \u00a7 7 odst. 3 z\u00e1kona \u010d. 480/2004 Sb., o n\u011bkter\u00fdch slu\u017eb\u00e1ch informa\u010dn\u00ed spole\u010dnosti. Va\u0161e osobn\u00ed \u00fadaje budeme pro tyto \u00fa\u010dely zpracov\u00e1vat po dobu 5 let od uzav\u0159en\u00ed smlouvy nebo jedn\u00e1n\u00ed o n\u00ed. Nesouhlas s takov\u00fdm zpracov\u00e1n\u00edm m\u016f\u017eete vyj\u00e1d\u0159it p\u00edsemn\u011b na adrese na\u0161\u00ed spole\u010dnosti nebo m\u016f\u017eete zamezit zas\u00edl\u00e1n\u00ed obchodn\u00edch sd\u011blen\u00ed pomoc\u00ed odkazu k odhl\u00e1\u0161en\u00ed od zas\u00edl\u00e1n\u00ed obchodn\u00edch sd\u011blen\u00ed, kter\u00fd je obsa\u017een v obchodn\u00edm sd\u011blen\u00ed."
              }
            </div>
            <h1
              className={classNames(
                "all",
                "h1",
                "h1__frLTK",
                "__wab_text",
                sty.h1___6D5WJ
              )}
            >
              {"Automatizovan\u00e9 zpracov\u00e1n\u00ed"}
            </h1>
            <div className={classNames("all", "__wab_text", sty.text__vOsgu)}>
              {
                "Abychom mohli posoudit, kter\u00fd finan\u010dn\u00ed produkt je pro V\u00e1s nejlep\u0161\u00ed a jak\u00e1 je Va\u0161e ochota a schopnost spl\u00e1cet, vyu\u017e\u00edv\u00e1me zpracov\u00e1n\u00ed formou automatizovan\u00e9ho rozhodov\u00e1n\u00ed, p\u0159i\u010dem\u017e toto je nezbytn\u00e9 k uzav\u0159en\u00ed smlouvy. Zpracov\u00e1n\u00ed prob\u00edh\u00e1 prost\u0159ednictv\u00edm vlastn\u00edho intern\u00edho syst\u00e9mu, kter\u00fd je propojen\u00fd s v\u00fd\u0161e uveden\u00fdmi registry, a kter\u00fd na z\u00e1klad\u011b vstupn\u00edch dat a pou\u017eit\u00e9ho algoritmu vyhodnot\u00ed potenci\u00e1ln\u00ed riziko spo\u010d\u00edvaj\u00edc\u00ed v neschopnosti \u010di neochot\u011b hradit z\u00e1vazky vznikl\u00e9 v p\u0159\u00edpad\u011b poskytnut\u00ed \u00fav\u011bru a z\u00e1rove\u0148 p\u0159isp\u00edv\u00e1 k odhalov\u00e1n\u00ed podvod\u016f. Takov\u00fd postup umo\u017e\u0148uje \u010dl. 22 odst. 2. p\u00edsm. a) Na\u0159\u00edzen\u00ed. V souvislosti s pou\u017eit\u00edm zpracov\u00e1n\u00ed formou automatizovan\u00e9ho rozhodnut\u00ed m\u00e1te pr\u00e1vo na lidsk\u00fd z\u00e1sah proti takov\u00e9mu rozhodnut\u00ed, pr\u00e1vo vyj\u00e1d\u0159it sv\u016fj n\u00e1zor proti v\u00fdsledku takov\u00e9ho zpracov\u00e1n\u00ed a pr\u00e1vo napadnout takov\u00e9 rozhodnut\u00ed."
              }
            </div>
            <h1
              className={classNames(
                "all",
                "h1",
                "h1__frLTK",
                "__wab_text",
                sty.h1___5Sc7O
              )}
            >
              {"P\u0159e\u010dt\u011bte si, jak\u00e1 m\u00e1te pr\u00e1va"}
            </h1>
            <div className={classNames("all", "__wab_text", sty.text__dVadM)}>
              {
                "Vezm\u011bte, pros\u00edme, na v\u011bdom\u00ed, \u017ee podle Na\u0159\u00edzen\u00ed m\u00e1te pr\u00e1vo:"
              }
            </div>
            <div className={classNames("all", "__wab_text", sty.text__iXbHd)}>
              <React.Fragment>
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul__s4QFu
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__sdLCr
                      )}
                    >
                      {
                        "zru\u0161it kdykoliv zas\u00edl\u00e1n\u00ed obchodn\u00edch sd\u011blen\u00ed,"
                      }
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__xl4Ke
                      )}
                    >
                      {
                        "vzn\u00e9st n\u00e1mitku proti zpracov\u00e1n\u00ed na z\u00e1klad\u011b na\u0161eho opr\u00e1vn\u011bn\u00e9ho z\u00e1jmu,"
                      }
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul__aIOvp
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__palbg
                      )}
                    >
                      {
                        "po\u017eadovat po n\u00e1s informaci, jak\u00e9 va\u0161e osobn\u00ed \u00fadaje zpracov\u00e1v\u00e1me,"
                      }
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul__h9QAx
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__r4Iu
                      )}
                    >
                      {
                        "vy\u017e\u00e1dat si u n\u00e1s p\u0159\u00edstup k t\u011bmto \u00fadaj\u016fm a tyto nechat aktualizovat nebo opravit, pop\u0159\u00edpad\u011b po\u017eadovat omezen\u00ed zpracov\u00e1n\u00ed,"
                      }
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul__tto2S
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__k06WL
                      )}
                    >
                      {
                        "po\u017eadovat po n\u00e1s v\u00fdmaz t\u011bchto osobn\u00edch \u00fadaj\u016f, v\u00fdmaz provedeme, pokud to nebude v rozporu s platn\u00fdmi pr\u00e1vn\u00edmi p\u0159edpisy nebo na\u0161imi opr\u00e1vn\u011bn\u00fdmi z\u00e1jmy,"
                      }
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul__iU4Hz
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__t7TZs
                      )}
                    >
                      {
                        "na p\u0159enositelnost \u00fadaj\u016f, pokud se jedn\u00e1 o automatizovan\u00e9 zpracov\u00e1n\u00ed na z\u00e1klad\u011b souhlasu nebo z d\u016fvodu pln\u011bn\u00ed smlouvy,"
                      }
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul__vcGiA
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__q61So
                      )}
                    >
                      {
                        "po\u017eadovat kopii zpracov\u00e1van\u00fdch osobn\u00edch \u00fadaj\u016f,"
                      }
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul__nNxn1
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__aye6V
                      )}
                    >
                      {
                        "na \u00fa\u010dinnou soudn\u00ed ochranu, pokud m\u00e1te za to, \u017ee va\u0161e pr\u00e1va podle Na\u0159\u00edzen\u00ed byla poru\u0161ena v d\u016fsledku zpracov\u00e1n\u00ed va\u0161ich osobn\u00edch \u00fadaj\u016f v rozporu s t\u00edmto Na\u0159\u00edzen\u00edm,"
                      }
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul__sRvC4
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__uKq8I
                      )}
                    >
                      {
                        "podat st\u00ed\u017enost u \u00da\u0159adu pro ochranu osobn\u00edch \u00fadaj\u016f (Pplk. Sochora 27, 170 00 Praha 7, e-mail: posta@uoou.cz, ID datov\u00e9 schr\u00e1nky: qkbaa2n)"
                      }
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
              </React.Fragment>
            </div>
            <Button
              data-plasmic-name={"button"}
              data-plasmic-override={overrides.button}
              className={classNames("__wab_instance", sty.button)}
              color={"success"}
              label={
                <div
                  className={classNames("all", "__wab_text", sty.text__nynWi)}
                >
                  {"P\u0159e\u010detl/a jsem si podm\u00ednky slu\u017eby"}
                </div>
              }
              onClick={async event => {
                const $steps = {};

                $steps["runCode"] = true
                  ? (() => {
                      const actionArgs = {
                        customFunction: async () => {
                          return window.close();
                        }
                      };
                      return (({ customFunction }) => {
                        return customFunction();
                      })?.apply(null, [actionArgs]);
                    })()
                  : undefined;
                if (
                  $steps["runCode"] != null &&
                  typeof $steps["runCode"] === "object" &&
                  typeof $steps["runCode"].then === "function"
                ) {
                  $steps["runCode"] = await $steps["runCode"];
                }
              }}
              size={"large"}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "freeBox", "button"],
  freeBox: ["freeBox", "button"],
  button: ["button"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  freeBox: "div";
  button: typeof Button;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicGdpr__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicGdpr__VariantsArgs;
    args?: PlasmicGdpr__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicGdpr__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicGdpr__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicGdpr__ArgProps,
          internalVariantPropNames: PlasmicGdpr__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicGdpr__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicGdpr";
  } else {
    func.displayName = `PlasmicGdpr.${nodeName}`;
  }
  return func;
}

export const PlasmicGdpr = Object.assign(
  // Top-level PlasmicGdpr renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),
    button: makeNodeComponent("button"),

    // Metadata about props expected for PlasmicGdpr
    internalVariantProps: PlasmicGdpr__VariantProps,
    internalArgProps: PlasmicGdpr__ArgProps,

    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/gdpr",
      pagePath: "/gdpr",
      params: {},
      query: {}
    })
  }
);

export default PlasmicGdpr;
/* prettier-ignore-end */
